import * as React from 'react';
import IconService from '../../../../../Services/IconService';
import CarsGroupCell from '../carsGroupCell';
import Config from '../../../../../../config';

interface IComponentProps {
  intl: any;
  allItems: any;
  id: any;
}

type Props = IComponentProps;

const AllCarsItemStatic = class extends React.PureComponent<Props> {
  render(): JSX.Element[] {
    const { allItems, id, intl } = this.props;

    return Object.values(allItems).map((item: any) => (
      <div
        style={{
          borderBottom: '1px solid #cccccc',
          background: '#D2E2FD',
          paddingTop: '13px',
        }}
        key={`item-${id}-${item.vehicleId}`}
        id={`item-${id}-${item.vehicleId}`}
        data-cy={`item-${item.vehicleId}`}
        className={`${item.active} hover-off d-flex flex-row flex-wrap d-lg-table-row d-md-table-row`}
      >
        <div className="d-block d-lg-table-cell d-md-table-cell font-weight-bold px-2 text-nowrap col-10 col-md-auto order-2">
          <div
            title={intl.formatMessage({
              id: `navigator.car.${
                Config.Vehicle.typeName[item.vehicleTypeId] === undefined
                  ? 'car'
                  : Config.Vehicle.typeName[item.vehicleTypeId]
              }`,
            })}
            style={{ marginRight: '15px' }}
          >
            <svg
              width="20px"
              height="20px"
              viewBox="10 5 30 30"
              version="1.1"
              className="rotate90"
              style={{
                float: 'left',
                marginRight: '10px',
                marginLeft: '-5px',
                position: 'relative',
                top: '4px',
              }}
            >
              <path
                id="path"
                d={IconService.getPath(item.vehicleTypeId)}
                fill="#000"
                fillOpacity="1"
                stroke="none"
              />
            </svg>
            <CarsGroupCell name={item.name} id={`name-${id}-${item.vehicleId}`} />
          </div>
        </div>
        <div className="d-block d-lg-table-cell d-md-table-cell d-md-table-cell px-3 col-auto order-3">
          {item.driverName && (
            <CarsGroupCell name={item.licenceNumber} id={`licence-${id}-${item.vehicleId}`} />
          )}
        </div>
        <div className="d-block d-lg-table-cell d-md-table-cell px-2 col col-md-auto order-4">
          <CarsGroupCell name={item.driverName} id={`driver-${id}-${item.vehicleId}`} />
        </div>
        <div className="d-block d-lg-table-cell d-md-table-cell px-3 col-auto order-5">
          <CarsGroupCell name={item.customerName} id={`customer-${id}-${item.vehicleId}`} />
        </div>
      </div>
    ));
  }
};

export default AllCarsItemStatic;
